/**
 * Admin routing. /login is public; everything else is behind <RequireAuth> inside the
 * app shell. Role-restricted areas add <RequireRole>. Module pages mount per phase.
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/shell/AppShell.jsx';
import { RequireAuth, RequireRole } from './auth/RequireAuth.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Users from './pages/Users.jsx';
import Settings from './pages/Settings.jsx';
import Beneficiaries from './pages/Beneficiaries.jsx';
import Audit from './pages/Audit.jsx';
import CasePipeline from './pages/cases/CasePipeline.jsx';
import CaseIntake from './pages/cases/CaseIntake.jsx';
import CaseDetail from './pages/cases/CaseDetail.jsx';
import ApprovalQueue from './pages/ApprovalQueue.jsx';
import Ledger from './pages/Ledger.jsx';
import Donors from './pages/Donors.jsx';
import Testimonials from './pages/Testimonials.jsx';
import Enquiries from './pages/Enquiries.jsx';
import Reports from './pages/Reports.jsx';
import BulkImport from './pages/BulkImport.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route path="/" element={<Dashboard />} />

        {/* Casework */}
        <Route path="/cases" element={<CasePipeline />} />
        <Route path="/cases/intake" element={<CaseIntake />} />
        <Route path="/cases/:id" element={<CaseDetail />} />
        <Route path="/beneficiaries" element={<Beneficiaries />} />
        <Route
          path="/approvals"
          element={
            <RequireRole roles={['approver', 'senior_approver']}>
              <ApprovalQueue />
            </RequireRole>
          }
        />
        <Route path="/ledger" element={<Ledger />} />
        <Route path="/donors" element={<Donors />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/enquiries" element={<Enquiries />} />
        <Route path="/transparency" element={<Reports />} />
        <Route
          path="/import"
          element={
            <RequireRole roles={['super_admin']}>
              <BulkImport />
            </RequireRole>
          }
        />

        {/* Reporting */}
        <Route
          path="/audit"
          element={
            <RequireRole roles={['super_admin']}>
              <Audit />
            </RequireRole>
          }
        />

        {/* Administration */}
        <Route
          path="/users"
          element={
            <RequireRole roles={['super_admin']}>
              <Users />
            </RequireRole>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireRole roles={['super_admin']}>
              <Settings />
            </RequireRole>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
